"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVENTURE_TAG_PATTERN = void 0;
exports.normalizeAdventureTag = normalizeAdventureTag;
exports.parseAdventureTagsLine = parseAdventureTagsLine;
exports.adventureMatchesAnyTag = adventureMatchesAnyTag;
exports.parseAdventureListFilterTags = parseAdventureListFilterTags;
/** Adventure tag token: lowercase alphanumeric, hyphens, underscores. */
exports.ADVENTURE_TAG_PATTERN = /^[a-z0-9][a-z0-9_-]*$/;
function normalizeAdventureTag(token) {
    const trimmed = token.trim().toLowerCase();
    if (!trimmed || !exports.ADVENTURE_TAG_PATTERN.test(trimmed)) {
        return null;
    }
    return trimmed;
}
function parseAdventureTagsLine(raw) {
    const invalidTokens = [];
    const seen = new Set();
    const tags = [];
    for (const part of raw.split(',')) {
        const normalized = normalizeAdventureTag(part);
        if (!normalized) {
            if (part.trim()) {
                invalidTokens.push(part.trim());
            }
            continue;
        }
        if (!seen.has(normalized)) {
            seen.add(normalized);
            tags.push(normalized);
        }
    }
    return { tags, invalidTokens };
}
/** True when adventure has at least one of the filter tags (any-match). */
function adventureMatchesAnyTag(adventureTags, filterTags) {
    if (filterTags.length === 0) {
        return true;
    }
    if (!adventureTags || adventureTags.length === 0) {
        return false;
    }
    const tagSet = new Set(adventureTags);
    return filterTags.some((tag) => tagSet.has(tag));
}
function parseAdventureListFilterTags(tagsAttr) {
    if (!tagsAttr || !tagsAttr.trim()) {
        return [];
    }
    const { tags } = parseAdventureTagsLine(tagsAttr);
    return tags;
}
//# sourceMappingURL=adventureTags.js.map